import React, { useContext, useMemo, useState } from "react";
import { Button, Col, message, Modal, Row, Select, Table, Tooltip } from "antd";
import { ModalProps } from "antd/es/modal";
import styles from "./index.module.scss";
import Form from "rc-field-form";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";
import FieldWithError from "components/FieldWithError";
import useRequest from "../../../../../../../utils/useRequest";
import {
    allCourses,
    date2Week,
    errorMessage,
    getCourseData
} from "../../../../../../../service/service";
import useRequestFn from "../../../../../../../utils/useRequestFn";
import {
    getCopyPaper,
    getHomeWorkPaperList,
    getHomeWorkPaperListProps,
    topicsSaveAll
} from "../../../../../../../service/homework";
import { ColumnProps } from "antd/lib/table/interface";
import HomeworkContext from "../../../../context";
import lodash from "lodash-es";
import useModalHandler from "../../../../../../../utils/v2/useModalHandler";
import { DrawViewCopyModal } from "../DrawViewCopyModal";

const formItemProps = {
    allowClear: true,
    style: {
        width: "100%"
    }
};

interface FormProps {
    course: string;
    batchNo: string;
}
interface Props extends ModalProps {
    onClose: () => void;
}
const Index = ({ onClose, ...props }: Props) => {
    const [data, setData] = useState<getHomeWorkPaperListProps[]>([]);
    const batchList = useAtomValue(termListAtom);
    const [form] = Form.useForm<FormProps>();
    const [CourseData] = useRequest(() => getCourseData({}));
    const courses = useMemo(() => allCourses(CourseData || []), [CourseData]);

    const [getData, { loading }] = useRequestFn(getHomeWorkPaperList);

    const modal = useModalHandler(undefined, { remove: true });

    async function handleFinish(params: FormProps) {
        try {
            const data = await getData({
                batchNo: params.batchNo,
                courseNo: params.course?.split("-")[0] || "",
                courseSeq: params.course?.split("-")[1] || ""
            });
            setData(data);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: ColumnProps<getHomeWorkPaperListProps>[] = [
        {
            title: "学期",
            dataIndex: "batchName",
            width: 150
        },
        {
            title: "课程信息",
            ellipsis: true,
            render(text, item) {
                return (
                    <Tooltip
                        placement="topLeft"
                        title={`${item.courseName}[${item.courseNo}-${item.courseSeq}]`}>
                        {`${item.courseName}[${item.courseNo}-${item.courseSeq}]`}
                    </Tooltip>
                );
            }
        },
        {
            title: "分数",
            dataIndex: "score",
            width: 100
        },
        {
            title: "创建时间",
            dataIndex: "createTime"
        },
        {
            title: "预览",
            width: 150,
            render: (text, record, index) => (
                <Button
                    style={{ padding: 0 }}
                    type="link"
                    size="small"
                    onClick={() => modal.open(record)}>
                    预览
                </Button>
            )
        }
    ];

    const [selectedRowKeys, setSelectedRowKeys] = useState<string[] | number[]>(
        []
    );

    const { paperParams, loadPaperData } = useContext(HomeworkContext);
    const [haveTop, { loading: haveLoading }] = useRequestFn(getCopyPaper);
    const [saveAction, { loading: saveLoading }] = useRequestFn(topicsSaveAll);

    async function save(selectId?: string | null) {
        const selectItem = lodash.find(data, {
            key: selectId ?? selectedRowKeys[0]
        }) as getHomeWorkPaperListProps;
        try {
            const data = await haveTop({
                courseNo: selectItem.courseNo,
                continunity: selectItem.continunity,
                courseSeq: selectItem.courseSeq,
                section: selectItem.section,
                week: date2Week(selectItem.createTime).toString(),
                weekTime: selectItem.week,
                weekTimeId: String(selectItem.weekTimeId),
                batchNo: selectItem.batchNo
            });

            if (data.length === 0) {
                return Modal.info({
                    title: "提示",
                    content: "没有可以复制的试题!"
                });
            }

            // @ts-ignore //。。。我也不想注解啊 这类型引用乱套了，我也没什么办法啊 我跪下了
            await saveAction(paperParams, data);

            onClose();
            loadPaperData();

            message.info("已添加到当前试题");
        } catch (e) {
            message.error("拷贝试题出错");
        }
    }

    return (
        <Modal
            {...props}
            centered
            width={1100}
            className={styles.root}
            onOk={() => save()}
            okButtonProps={{
                disabled: selectedRowKeys.length === 0,
                loading: saveLoading || haveLoading
            }}
            title="复制作业">
            <Form className={styles.before} form={form} onFinish={handleFinish}>
                <Row type="flex" align="top" gutter={15} justify="end">
                    <Col span={2} className={styles.label}>
                        学期:
                    </Col>
                    <Col span={6}>
                        <FieldWithError name="batchNo">
                            <Select {...formItemProps} placeholder="请选择学期">
                                {batchList.map(item => (
                                    <Select.Option
                                        value={item.batchNo}
                                        key={item.batchNo}>
                                        {item.batchName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </FieldWithError>
                    </Col>
                    <Col span={3}>
                        <Button
                            style={{ width: "100%" }}
                            icon="search"
                            htmlType="submit"
                            type="primary"
                            loading={loading}>
                            搜索
                        </Button>
                    </Col>
                </Row>
            </Form>
            <br />
            <Table
                rowKey="key"
                dataSource={data}
                columns={columns}
                pagination={false}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys: selectedRowKeys,
                    onChange: e => setSelectedRowKeys(e)
                }}
                scroll={{
                    y: "450px"
                }}
            />

            {modal.render(
                <DrawViewCopyModal onSubmit={save} onClose={modal.close} />
            )}
        </Modal>
    );
};

export default Index;
